import { render } from "./BannerForm.vue?vue&type=template&id=6220d84b"
import script from "./BannerForm.vue?vue&type=script&lang=js"
export * from "./BannerForm.vue?vue&type=script&lang=js"
script.render = render

export default script